module.exports = __webpack_public_path__ + "img/beer_id-20.aa0946b4.png";